import Image from 'next/image';
import { FC } from 'react';

import { SECTIONS_IDS } from '../../../constants/sections';
import { Box } from '../common/Box';
import { Container } from '../common/Container';
import { Flex } from '../common/Flex';
import { Slider } from '../common/Slider';
import { Text } from '../common/Text';

import styles from './ScaleBlock.module.scss';

export const ScaleBlock: FC = () => {
  const cascadingBox = (
    <Box
      className={styles.card}
      title="Cascading / Smart routing"
      description="Automatically route transactions across providers based on rules: region, cost, approval rate, limits and risk signals"
    >
      <div className={styles.gif}>
        <Image
          src="/assets/scale1-v4.png"
          alt="Cascading / Smart routing"
          width={1116}
          height={602}
          layout="responsive"
          sizes="(min-width: 1280px) 50vw, 100vw"
        />
      </div>
    </Box>
  );

  const FXBox = (
    <Box
      className={styles.card}
      title="FX / Currency conversion"
      description="Handle multi-currency pricing and settlement logic with configurable conversion flows"
    >
      <div className={styles.gif}>
        <Image
          src="/assets/scale2-v4.png"
          alt="FX / Currency conversion"
          width={1116}
          height={602}
          layout="responsive"
          sizes="(min-width: 1280px) 50vw, 100vw"
        />
      </div>
    </Box>
  );

  const slides = [
    {
      id: 'CascadingBox',
      content: cascadingBox,
    },
    {
      id: 'FXBox',
      content: FXBox,
    },
  ];

  return (
    <Container className={styles.root} id={SECTIONS_IDS.developers}>
      <Flex direction={'column'} gap={4}>
        <Text type={'h2'}>Scale to new markets — without rebuilding your payments stack</Text>

        <Text type={'body16'}>
          Add providers, routes, methods, and currencies through orchestration — while keeping one control plane
        </Text>
      </Flex>

      <div className={styles.grid}>
        {cascadingBox}

        {FXBox}
      </div>

      <div className={styles.slider}>
        <Slider items={slides} />
      </div>
    </Container>
  );
};
